export default "__VITE_ASSET__DE$f5lCm__"